module.exports = __webpack_public_path__ + "img/icon.a76ecedb.svg";